export class Site {
  SiteId?: number;
  SiteName: string;
  //TripTypeId?: number;
  //TripType: string;
  TripCategoryId?: number;
  CategoryName: string;
  OrderStatusId: number;
  OrderStatus: string;
  SpecialPaymentMethodId?: number;
  SpecialPaymentMethodPaymentsNumber?: number;
}

export class TripType {
  TripTypeId?: number;
  TripType: string;
}

export class TripCategory {
  TripCategoryId?: number;
  CategoryName: string;
}

export class OrderStatus {
  OrderStatusId?: number;
  OrderStatus: string;
}

export class Cycle {
  CycleId: number;
  CycleName: string;
  StartDate?: Date;
  EndDate?: Date;
  CycleGrouper: string;
  CardsPending: number;
  CardsBillSuccess: number;
  CardsBillFailure: number;
  CycleCurrency: string;
  mustBeConverted: boolean;
  Rate?: number;

  label: string;    // client helper property
  value: string;    // client helper property
}

export class Payment {
  PaymentId: number;
  RegistrationId: number;
  TokenApprovalNumber: string;
  NumOfPayments?: number;
  CardOwnerID: string;
  CardValidityMonth: string;
  CardValidityYear: string;
  TokenExDate: string;
  VFLowProfileCode: string;
  Token: string;
  CreditCardOwnerName: string;
  CreditCardAmount?: number;
  BillingStatusId?: number;
  BillingStatus: string;
  BillingStatusDate?: Date;
  BillingLastErrorCode: string;
  BillingLastErrorDescription: string;
  BillingManualStatusId?: number;
  CardName: string;
  TravelersInPayment: string;
  CardValidity: string;

  Selected: boolean;
  AllowedToSelect: boolean;
  AllowedToRecharge: boolean;

  isCanceled: boolean;

  PaymentOrRefund: number;    //1-payment, 2-refund

  VfInternalDealNumber: string;


  CycleCurrency: string;
  Rate?: number;
  AmountNISPayed?: number;
  AmountNISWillBePayed?: number;

  Notes: string;

  MaxPaymentsNumber?: number;

  CycleId: number;
  CycleGrouper:string;
  CycleName:string;

  CreditCardNumber: string;

  TravelersCanceledInPayment: number;

  SpecialMethodPayments: SpecialMethodPayment[];
  isSpecialPayment:boolean;
  SpecialPayment_NumberOfPaymentsPlaned: number;
  SpecialPayment_NumberOfPaymentsExecuted: number;
  SpecialPayment_TotalAmountPayedInCurrency: number;
  SpecialPayment_TotalAmountPayedInNIS: number;
  SpecialPayment_AmountNextInCurrency: number;
  SpecialPayment_AmountNextInNIS: number;

  SpecialPayment_WholeReminderInCurrency: number;
  SpecialPayment_WholeReminderInNIS: number;
  SpecialPayment_isWholeReminderChargeAllowed: boolean;
  SpecialPayment_ChargeByWholeReminder: boolean;
  
}

export class SpecialMethodPayment {
  Id: number;
  PaymentId: number;
  PaymentNumber: number;
  AmountInCurrency: number;
  AmountInNIS: number;
  PaymentDate: Date;
}





// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/model/trip.ts